<template>
    <div class="btn-group mb-3 d-flex" role="group">
        <button type="button"
                class="btn"
                :class="values[0].value === value?'active':''"
                @click="$emit('change', values[0].value)"
                v-text="values[0].text"/>
        <button type="button"
                class="btn"
                :class="values[1].value === value?'active':''"
                @click="$emit('change', values[1].value)"
                v-text="values[1].text"/>
    </div>
</template>

<script>
    export default {
        props: ['values', 'value']
    }
</script>

<style lang="scss" scoped>
    @import '../styles/colors.scss';

    .btn-group {
        .btn {
            border-radius: 3px;
            border: 2px solid #DFDFDF;
            font-weight: bold;

            &:nth-child(1) {
                border-right: none;
                border-radius: 3px 0 0 3px;
            }

            &:nth-child(2) {
                border-left: none;
                border-radius: 0 3px 3px 0;
            }

            &.active {
                border: none;
                border-radius: 3px;
                background: $greenGradient;
                color: #fff;
            }
        }
    }
</style>
